import React from 'react'

import { Box } from '@mui/material'

function Logo({ height = 32 }) {
  return (
    <Box display='flex' alignContent='center'>
      <img
        height={height}
        src='/images/icons/icon-36.png'
        alt=''
        srcSet='/images/icons/icon-36.png,
        /images/icons/icon-36.png 1.5x,
        /images/icons/icon-48.png 2x,
        /images/icons/icon-72.png 3x,
        /images/icons/icon-96.png 4x,
        /images/icons/icon-144.png 6x,
        /images/icons/icon-192.png 8x'
      />
    </Box>
  )
}

export default Logo
